import {
  Box,
  Button,
  CircularProgress,
  styled,
  TextField,
  Typography,
} from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const SearchInput = styled(TextField)({
  marginBottom: 30,
})

export const LastTransfersTitle = styled(Typography)({
  marginBottom: 20,
})

export const ClientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
  overflow: "scroll",
})

export const StyledButton = styled(Button)({
  marginTop: "auto",
})

export const Loading = styled(CircularProgress)({
  margin: "auto",
})
